export default {
    tabSelected: 'informations',
    linkedid: 0,
    linkedtype: '',
    identity: {},
    dataFetch: [],
    dataMap: [],
    mainContact: [],
    timeline: {},
    permissions: {},
    sellsyInformations: {},
    tags: [],
    avatar: {},
    favorites: [],
    activeFavorites: [],
    favLimit: 3, // means 4 because we start at 0,
    routes: [],
    setDefaultFavorite: true,
    availableStatCards: [],
    currencies: [],
    databots: {},
    agendaViewConfig: {}
}